import React, { useState } from "react";
import { MdDeleteOutline } from "react-icons/md";
import { BiShow } from "react-icons/bi";
import { useDispatch } from "react-redux";
import { IoMdClose } from "react-icons/io";
import { axios } from "../../../../Global";
import PromptElement from "../../PromptElement";
import { setAppError } from "../../../../store/userSlice";
import CandidateFileUpload from "./CandidateFIleUpload";

export default function FileViewPopup({
  filesData = [],
  filesPopupState,
  setFilesPopupState,
  allFiletypes,
  setUpdateData,
  arrivalId
}) {
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  const [showPromptElement, setShowPromptElement] = useState({
    open: false,
    id: null,
  });
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const titles = ["Sl No.", "File Name", "File Type", "Action"];
  const [uploadFilePopupState, setUploadFilePopupState] = useState({
    open: false,
  });

  const handleDelete = async (id) => {
    setDeleteLoading(true);
    async function deleteRequest(id) {
      axios
        .delete(`/dashboard/arrival-notification/${arrivalId}/candidate-file-delete/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          setDeleteLoading(false);
          dispatch(
            setAppError({
              msg: res.data?.message || "Deleted successfully",
              color: "success",
            })
          );
          setUpdateData(prev => !prev)
        })
        .catch((err) => {
          setDeleteLoading(false);
          dispatch(
            setAppError({
              msg: err?.message,
            })
          );
        });
    }
    await deleteRequest(id);
  };

  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center  ${
        filesPopupState?.open ? "flex" : "hidden"
      }`}
    >
      {uploadFilePopupState.open && (
        <CandidateFileUpload
          uploadFilePopupState={uploadFilePopupState}
          setUploadFilePopupState={setUploadFilePopupState}
          allFiletypes={allFiletypes}
          filesPopupState={filesPopupState}
          setUpdateData={setUpdateData}
          arrivalId={arrivalId}
        />
      )}

      {showPromptElement.open && (
        <PromptElement
          showPromptElement={showPromptElement}
          setShowPromptElement={setShowPromptElement}
          deleteHandler={handleDelete}
        />
      )}

      <div className=" min-w-[95%] lg:min-w-max max-w-xl h-auto min-h-[14rem] rounded-md bg-white/90 flex justify-center items-center flex-col p-6  gap-4">
        <div className="flex justify-between items-center w-full">
          <h1 className="text-xl font-semibold self-start">Files</h1>
          <button
            className="text-md font-semibold cursor-pointer flex items-center gap-1"
            onClick={() => {
              setFilesPopupState((p) => ({ open: false }));
            }}
          >
            <IoMdClose className="font-bold" /> Close
          </button>
        </div>
        <button
          className="p-2 px-4 rounded-md bg-red text-white my-2 self-start"
          onClick={() => setUploadFilePopupState({ open: true })}
        >
          Upload File
        </button>
        <div className="p-2 w-full max-w-xs sm:max-w-full">
          <div
            className={` grid justify-items-center grid-cols-table-4  overflow-scroll min-h-[14rem]  gap-2 p-6 bg-white   items-center rounded-md max-h-[20rem] max-w-full `}
          >
            {titles?.map((title, index) => (
              <p key={index} className="font-semibold uppercase">
                {title}
              </p>
            ))}
            {filesData?.length <= 0 && (
              <p className="col-span-10"> No Data found </p>
            )}

            {filesData?.length > 0 &&
              filesData?.map((data, index) => (
                <React.Fragment key={data?.id}>
                  <p>{Number(index) + 1}</p>

                  <p>{data?.file_name}</p>
                  <p>{data?.file_type}</p>
                  <div className="flex gap-3 justify-center items-center">
                    <button className="p-1 px-2 rounded-md ring-1 ">
                      <a
                        href={data?.file_path}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <BiShow size={"1.4rem"} />
                      </a>
                    </button>
                    <button
                      className="p-1 px-2 rounded-md ring-1 ring-red bg-red text-white "
                      onClick={() =>
                        setShowPromptElement({ open: true, id: data?.id })
                      }
                      disabled={loading || deleteLoading}
                    >
                      <MdDeleteOutline size={"1.4rem"} />
                    </button>
                  </div>

                  <hr className="border-[1.5px] border-slate-100  w-full col-span-full" />
                </React.Fragment>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}
